"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFeatureArea = void 0;
var base_feature_area_1 = require("./base-feature-area");
/**
 * Feature/s Feature Area for evaluating Feature/s
 * @privateRemarks
 * we extend {@link BaseFeatureArea} to allow exposing common utilities/methods amongst feature areas
 * we implement {@link FeatureFeatureAreaInterface} to ensure consistent API amongst feature areas
 */
var FeatureFeatureArea = /** @class */ (function (_super) {
    __extends(FeatureFeatureArea, _super);
    /**
     * FeatureFeatureArea class constructor that calls parent {@link BaseFeatureArea} ctor
     * to setup appPermissions which are shared across feature areas through that parent class
     * allows us to conditionally execute user povided logic
     * @param appPermissions data received from BE on init {@link EntityPermissionMap}
     * @param altEvalFn optional logic to run in BaseFeatureArea.evalPermission {@link AltPermissionEval}
     */
    function FeatureFeatureArea(appPermissions, altEvalFn) {
        return _super.call(this, appPermissions, altEvalFn) || this;
    }
    /**
     * Used by {@link Permissions} that returns object to begin a Permission Chain and eventually eval permissions
     * @param currentPermission {@link PartialPermission} passed around and eventually evaluated
     * @param entityOptions optional object (Feature, Page, etc.) and other options for when it's necessary to check
     * @returns object with `action` method for chaining as {@link ActionLink}
     *
     * @internal this should be implemented on all feature areas
     */
    FeatureFeatureArea.prototype.execute = function (currentPermission, entityOptions) {
        var _this = this;
        return {
            action: function (action) {
                return _this._action(action, currentPermission, entityOptions);
            }
        };
    };
    /**
     * Early return {@link ActionLink} - since source/target don't change, we hard code and
     * immediately eval to a true/false after invoking .action()
     * @param action one of {@link FeatureActionName}
     * @param currentPermission current state of permissions in the chain
     * @param entityOptions optional object (Feature, Page, etc.) and other options for when it's necessary to check
     * @returns boolean
     */
    FeatureFeatureArea.prototype._action = function (action, currentPermission, entityOptions) {
        currentPermission = __assign({ action: action, source: '*', target: '*' }, currentPermission);
        return _super.prototype.evalPermission.call(this, currentPermission, entityOptions);
    };
    return FeatureFeatureArea;
}(base_feature_area_1.BaseFeatureArea));
exports.FeatureFeatureArea = FeatureFeatureArea;
